import {
  ReportComponentDataProps,
  ReportDashboardComponent,
  ReportDashboardComponentKind,
} from '@core/reports-types';

export const getComponentDataProps = <
  T extends ReportDashboardComponent | null,
  R = T extends null ? null : ReportComponentDataProps,
>(
  component: T,
): R => {
  if (!component) {
    return <R>null;
  }
  const x: ReportComponentDataProps = {
    ...(component.kind === ReportDashboardComponentKind.TimeBased
      ? {
          kind: component.kind,
          startPoint: component.startPoint,
          endPoint: component.endPoint,
        }
      : {
          kind: component.kind,
        }),
    metric: component.metric,
    options: component.options,
    primaryGroup: component.primaryGroup,
    secondaryGroup: component.secondaryGroup,
    sortBy: component.sortBy,
    sortOrder: component.sortOrder,
    filters: component.filters,
    dateFilter: component.dateFilter,
    dateField: component.dateField,
    settings: component.settings
      ? {
          ...(component.settings.interval ? { interval: component.settings.interval } : {}),
        }
      : {},
  };

  return <R>x;
};
